import React, { useEffect, useState } from 'react';
var Landing = ()=>{
	return <div>
		<pre style={{ textAlign: 'center' }}>{`
______            __                 _   
| ___ \\          / _|               | |  
| |_/ /_ _ _   _| |_ _ __ ___  _ __ | |_ 
|  __/ _\` | | | |  _| '__/ _ \\| '_ \\| __|
| | | (_| | |_| | | | | | (_) | | | | |_ 
\\_|  \\__,_|\\__, |_| |_|  \\___/|_| |_|\\__|
            __/ |                        
            |___/                         
		`}</pre>
	</div>
}

export default Landing;